import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { withStyles } from "@mui/styles";
import moment from "moment";
import Timepicker from "../Input/Timepicker";
import ValidateIcon from "@mui/icons-material/Check";
import CircularProgress from "@mui/material/CircularProgress";
import { throwErrorMessage } from "../../lib/error_helper";
import { floatToTime, timeToFloat } from "../../time";
import { getCurrentFunctionName } from "../../performanceModeManager";
import DatePicker from "../Input/DatePicker";

const styles = {
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class PauseInterventionModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpenned: props.opened,
            startDate: props.startDate,
            startTime: moment(floatToTime(props.startTime)),
            endDate: moment().seconds(0).milliseconds(0),
            endTime: moment().seconds(0).milliseconds(0),
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;

        if (!modifiedState.modalOpenned && modifiedState.modalOpenned !== nextProps.opened) {
            let startTime = moment(floatToTime(nextProps.startTime));
            let startDate = moment(nextProps.startDate);
            startDate.hours(startTime.hour);
            startDate.minutes(startTime.minute);
            startDate.seconds(0).milliseconds(0);
            let maxDate = startDate.add(1, "days");

            modifiedState.endDate = moment.min(moment().seconds(0).milliseconds(0), maxDate);
            modifiedState.endTime = moment.min(moment().seconds(0).milliseconds(0), maxDate);
        }

        modifiedState.startDate = nextProps.startDate;
        modifiedState.startTime = nextProps.startTime;
        modifiedState.modalOpenned = nextProps.opened;
        return modifiedState;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.opened !== nextProps.opened || this.state.endTime !== nextState.endTime;
    }

    close() {
        this.setState({ modalOpenned: false });
        this.props.closeModal();
    }

    onEndTimeChange(newValue) {
        this.setState({
            endTime: moment(newValue).seconds(0).milliseconds(0),
        });
    }

    validatePause() {
        let startDate = moment(this.state.startDate);
        let startTime = this.state.startTime;

        if (moment.isMoment(this.state.startTime)) {
            let startTimeAsDate = this.state.startTime.toDate();
            startTime = timeToFloat(startTimeAsDate.getHours(), startTimeAsDate.getMinutes());
        }

        let endTimeAsDate = this.state.endTime.toDate();
        let endTime = timeToFloat(endTimeAsDate.getHours(), endTimeAsDate.getMinutes());
        let now = new Date();
        let nowTime = timeToFloat(now.getHours(), now.getMinutes());

        if ((this.state.endDate.isAfter(now, "day") || this.state.endDate.isSame(now, "day")) && nowTime < endTime) {
            this.props.throwErrorMessage({
                title: "Erreur",
                message: "L'heure d'arrivée doit-être antérieure à l'heure actuelle",
            });

            return;
        }

        if (
            startDate.isAfter(this.state.endDate, "day") ||
            (startDate.isSame(this.state.endDate, "day") && startTime >= endTime)
        ) {
            this.props.throwErrorMessage({
                title: "Erreur",
                message: "La date d'arrivée doit-être antérieure à la date de départ",
            });

            return;
        }

        this.props.pause(this.state.endDate, this.state.endTime);
    }

    onDateChange() {}

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        return (
            <Dialog
                fullScreen
                aria-labelledby="simple-dialog-title"
                open={this.state.modalOpenned}
                onClose={this.close.bind(this)}
            >
                <Toolbar />
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit" className={classes.flex}>
                            {"Interrompre l'intervention " + this.props.numOT}
                        </Typography>
                        {this.props.gpsInProgress ? (
                            <CircularProgress />
                        ) : (
                            <IconButton
                                color="inherit"
                                onClick={this.validatePause.bind(this)}
                                aria-label="Validate"
                                id="btn-validate-pause-intervention"
                            >
                                <ValidateIcon />
                            </IconButton>
                        )}
                    </Toolbar>
                </AppBar>
                <DialogContent className="without-side-padding">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <DatePicker
                                disabled
                                value={moment(this.state.startDate)}
                                label="Date d'arrivée"
                                emptyLabel="La date est invalide"
                                invalidDateMessage="La date est invalide"
                                invalidLabel="La date est invalide"
                                format="DD/MM/YYYY"
                                className="full_size"
                                onChange={this.onDateChange}
                                fullWidth={true}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <Timepicker
                                disabled
                                id="start-date"
                                mode="24h"
                                label="Heure d'arrivée"
                                className="full_size"
                                cancelLabel="Annuler"
                                value={floatToTime(this.state.startTime)}
                                onChange={this.onDateChange}
                                fullWidth={true}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <DatePicker
                                disabled
                                value={moment(this.state.endDate)}
                                label={"Date de départ"}
                                emptyLabel="La date est invalide"
                                invalidDateMessage="La date est invalide"
                                invalidLabel="La date est invalide"
                                format="DD/MM/YYYY"
                                className="full_size"
                                onChange={this.onDateChange}
                                fullWidth={true}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                            <Timepicker
                                id="end-date"
                                label="Heure de départ"
                                mode="24h"
                                className="full_size"
                                cancelLabel="Annuler"
                                value={new Date(this.state.endTime)}
                                onChange={this.onEndTimeChange.bind(this)}
                                fullWidth={true}
                            />
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        throwErrorMessage: (errObj) => dispatch(throwErrorMessage(errObj)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(PauseInterventionModal);
